import { resultTablesResourceName } from "store/configureResources";

import { useResource } from "store/resources/actions/useResource";

export const useResultTables = () =>
    useResource({
        resourceName: resultTablesResourceName,
        key: resultTablesResourceName,
    }) as [string[] | undefined, boolean | undefined, any];
